import { useState } from 'react'
import { StoredProfile } from '@/utils/storage'
import { openTelegramLink } from '@/utils/telegram'
import { texts } from '@/texts'
import { ProfileView } from './ProfileView'
import { DailyHoroscope } from './DailyHoroscope'
import { ProfileEditForm } from './ProfileEditForm'

const ADMIN_TELEGRAM_URL =
  (import.meta.env.VITE_ADMIN_TELEGRAM_URL as string | undefined) ?? 'https://t.me/wapitii80'

interface MainViewProps {
  profile: StoredProfile
  onProfileUpdate: (profile: StoredProfile) => void
}

type TabType = 'horoscope' | 'profile'

export function MainView({ profile, onProfileUpdate }: MainViewProps) {
  const [activeTab, setActiveTab] = useState<TabType>('horoscope')
  const [isEditing, setIsEditing] = useState(false)

  if (isEditing) {
    return (
      <ProfileEditForm
        profile={profile}
        onSave={(updatedProfile) => {
          onProfileUpdate(updatedProfile)
          setIsEditing(false)
        }}
        onCancel={() => setIsEditing(false)}
      />
    )
  }

  return (
    <div style={{
      minHeight: '100vh',
      padding: 'var(--spacing-4)',
      display: 'flex',
      flexDirection: 'column',
    }}>
      {/* Marke */}
      <div style={{
        textAlign: 'center',
        marginBottom: 'var(--spacing-4)',
        paddingTop: 'var(--spacing-3)',
      }}>
        <div className="mg-brand" style={{ fontSize: '2.6rem' }}>
          Zahlio<span className="mg-brand-heart">{'♥︎'}</span>
        </div>
        <p className="mg-brand-sub" style={{ fontSize: '0.85rem', margin: '2px 0 0 0' }}>
          {texts.app.brandSubtitle}
        </p>
      </div>

      {/* Tabs */}
      <div className="mg-tabs" style={{
        maxWidth: '500px',
        margin: '0 auto var(--spacing-4)',
        width: '100%',
        padding: '0 var(--spacing-2)',
      }}>
        <button
          className={`mg-tab${activeTab === 'horoscope' ? ' active' : ''}`}
          onClick={() => setActiveTab('horoscope')}
        >
          {texts.mainView.tabHoroscope}
        </button>
        <button
          className={`mg-tab${activeTab === 'profile' ? ' active' : ''}`}
          onClick={() => setActiveTab('profile')}
        >
          {texts.mainView.tabProfile}
        </button>
      </div>

      {/* Inhalt */}
      <div style={{
        flex: 1,
        maxWidth: '500px',
        margin: '0 auto',
        width: '100%',
        padding: '0 var(--spacing-2)',
        overflowY: 'auto',
      }}>
        {activeTab === 'horoscope' && <DailyHoroscope profile={profile} />}
        {activeTab === 'profile' && (
          <ProfileView
            profile={profile}
            onEdit={() => setIsEditing(true)}
            onProfileUpdate={onProfileUpdate}
          />
        )}
      </div>

      {/* Footer / Credit */}
      <div className="mg-footer-cta" style={{
        marginTop: 'var(--spacing-6)',
        textAlign: 'center',
        paddingBottom: 'var(--spacing-2)',
      }}>
        <a
          className="mg-footer-btn"
          href="https://www.anitafurrer.ch/"
          target="_blank"
          rel="noopener noreferrer"
        >{texts.mainView.footerButtonWebsite}</a>
        <a
          className="mg-footer-btn mg-footer-btn-primary"
          href={ADMIN_TELEGRAM_URL}
          onClick={(e) => {
            e.preventDefault()
            openTelegramLink(ADMIN_TELEGRAM_URL)
          }}
        >{texts.mainView.footerButtonTelegram}</a>
        <p className="mg-footer-sub" style={{ margin: 'var(--spacing-3) 0 0 0' }}>
          {texts.mainView.footerOffer}<br />
          {texts.mainView.footerImpulse}
        </p>
      </div>
    </div>
  )
}
